import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from 'src/games/XraySlider/scenes/GameIntro';

interface XraySliderProps {
    onComplete: () => void;

}

interface XraySliderState {
}

const gameConfig: GameConfig = {
    title: "Sliding Xray Game",
    version: "0.2",
    backgroundColor: "#000000",
};

class PhaserXraySlider extends React.Component<XraySliderProps, XraySliderState> {
    private game: Phaser.Game;
    constructor(props: XraySliderProps) {
        super(props);
        bindAllOfThis(this, PhaserXraySlider.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={gameConfig} onComplete={this.props.onComplete} />
        </div>);
    }
}

export default PhaserXraySlider;



// WEBPACK FOOTER //
// ./src/games/XraySlider/Main.tsx